import { showroomStats } from "@/mocks/showroomData";

export default function ShowroomHero() {
  return (
    <section className="relative w-full min-h-screen overflow-hidden bg-[#0d0d0d]">
      {/* Full-bleed background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vast%20luxury%20furniture%20showroom%20interior%2C%20dramatic%20high%20ceilings%20with%20industrial%20pendant%20lights%2C%20polished%20concrete%20floors%2C%20curated%20furniture%20displays%20in%20warm%20amber%20lighting%2C%20Chicago%20West%20Loop%20loft%20architecture%2C%20editorial%20interior%20photography%2C%20cinematic%20wide%20angle%2C%20dark%20moody%20atmosphere%20with%20warm%20golden%20accents%2C%20sophisticated%20and%20minimal&width=1600&height=900&seq=801&orientation=landscape"
          alt="FORM Chicago Showroom"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d0d0d]/90 via-[#0d0d0d]/50 to-[#0d0d0d]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d]/80 via-transparent to-[#0d0d0d]/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full min-h-screen flex flex-col justify-between px-6 md:px-10 lg:px-16 pt-32 pb-12 md:pb-16">
        <div className="flex-1 flex flex-col justify-center max-w-2xl">
          <p
            className="text-[11px] uppercase tracking-[0.28em] text-[#B8422E] mb-6"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            / West Loop, Chicago
          </p>
          <h1
            className="text-5xl md:text-6xl lg:text-[80px] font-extrabold text-white leading-[1.02] tracking-[-0.025em]"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            The
            <br />
            Showroom
          </h1>
          <p
            className="mt-6 text-base md:text-lg text-white/55 leading-relaxed max-w-md"
            style={{ fontFamily: "'Public Sans', sans-serif" }}
          >
            8,000 square feet of curated furniture in Chicago&apos;s West Loop. Every piece on display. Every material available to touch.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#spaces"
              className="inline-flex items-center gap-2 bg-white text-[#1A1C1E] px-7 py-3.5 text-[13px] font-semibold hover:bg-[#B8422E] hover:text-white transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
            >
              Explore the Spaces
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#visit"
              className="inline-flex items-center gap-2 border border-white/25 text-white px-7 py-3.5 text-[13px] font-semibold hover:border-white/60 transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
            >
              <i className="ri-calendar-line" />
              Book a Consultation
            </a>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/[0.06]">
          {showroomStats.map((stat) => (
            <div
              key={stat.label}
              className="bg-[#0d0d0d]/60 backdrop-blur-sm px-6 py-5 md:py-6"
            >
              <p
                className="text-2xl md:text-3xl font-extrabold text-white tracking-[-0.02em]"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {stat.value}
                {stat.unit && (
                  <span className="text-base font-normal text-[#6C7278] ml-1">{stat.unit}</span>
                )}
              </p>
              <p
                className="mt-1 text-[11px] uppercase tracking-[0.16em] text-[#6C7278]"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
